define('models/lead_note',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'lead-notes/' + this.id + '/' ) :
                ( App.Config.apiBase + 'lead-notes/' );
        },

        defaults: function () {
            return {
                id: null,
                lead: null,
                note: '',
                created: ''
            };
        }
    });
});
